import type { VideoPlayer } from '@zoom/videosdk';
import { useAtomValue } from 'jotai';
import { useEffect, useRef } from 'react';

import { remoteScreenShareAudioDelegatorAtom, remoteScreenShareVideoDelegatorAtom } from '../video-sdk';

export function useRemoteScreenShare() {
  const remoteParticipantScreenShareRef = useRef<HTMLVideoElement | VideoPlayer>(null);
  const remoteParticipantAudioScreenShareRef = useRef<HTMLAudioElement>(null);
  const remoteScreenShareVideoDelegator = useAtomValue(remoteScreenShareVideoDelegatorAtom);
  const remoteScreenShareAudioDelegator = useAtomValue(remoteScreenShareAudioDelegatorAtom);

  useEffect(
    function handleScreenShareAttachment() {
      const videoElement = remoteParticipantScreenShareRef.current;
      if (!remoteScreenShareVideoDelegator || !videoElement) return;
      remoteScreenShareVideoDelegator.attach(videoElement);
      return function cleanup() {
        remoteScreenShareVideoDelegator.detach(videoElement);
      };
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [remoteScreenShareVideoDelegator, remoteParticipantScreenShareRef],
  );

  useEffect(
    function handleScreenShareAudioAttachment() {
      const audioElement = remoteParticipantAudioScreenShareRef.current;
      if (!remoteScreenShareAudioDelegator || !audioElement) return;
      remoteScreenShareAudioDelegator.attach(audioElement);
      return function cleanup() {
        remoteScreenShareAudioDelegator.detach(audioElement);
      };
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [remoteScreenShareAudioDelegator, remoteParticipantAudioScreenShareRef],
  );

  return {
    remoteParticipantScreenShareRef,
    remoteParticipantAudioScreenShareRef,
  };
}
